import { gql } from '@apollo/client';
import { CRM_CONTRACT_FIELDS } from './queries';

export const CREATE_CRM_CONTRACT = gql`
    mutation CreateCrmContract($input: CreateCrmContractInput!) {
        createCrmContract(input: $input) {
            ${CRM_CONTRACT_FIELDS}
        }
    }
`;

/**
 * Promote a draft to "sent" and email the contact a signing link (Phase 4).
 * `subject`/`bodyHtml` carry the admin's composed email (or a prefilled
 * template); omitted ⇒ the backend's default email. The signing link is woven
 * into the body server-side.
 */
export const SEND_CRM_CONTRACT = gql`
    mutation SendCrmContractForSignature($id: String!, $subject: String, $bodyHtml: String) {
        sendCrmContractForSignature(id: $id, subject: $subject, bodyHtml: $bodyHtml) {
            ${CRM_CONTRACT_FIELDS}
        }
    }
`;
